// extracted by mini-css-extract-plugin
export default {"loaderOuter":"Loader_loaderOuter__s61C7","loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0","fullScreen":"Loader_fullScreen__JOBi+"};